import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const MAP_BASE = "https://customer-assets.emergentagent.com/job_pandemic-ready/artifacts/wtuauqq3_image.png";

export default function BSL4Map() {
  return (
    <div className="relative w-full overflow-hidden rounded-lg border border-[#1F2937]">
      {/* Real Europe BSL-4 map (source: thebulletin.org/global-biolabs) */}
      <img
        src={MAP_BASE}
        alt="BSL-4 laboratories across Europe — all locations marked, Pécs highlighted"
        className="w-full block"
        loading="lazy"
      />

      {/* Red Pécs highlight overlay (over the existing blue dot) */}
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.3, duration: 0.4 }}
        className="absolute"
        style={{ left: "55.8%", top: "62.5%", transform: "translate(-50%, -50%)" }}
      >
        <div className="w-5 h-5 md:w-6 md:h-6 rounded-full bg-[#EE1D25] border-2 border-[#EE1D25]/40 shadow-[0_0_16px_rgba(238,29,37,0.5)] relative z-10" />
        <div className="absolute inset-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-[#EE1D25]/25 animate-ping" />
      </motion.div>

      {/* Pécs label */}
      <motion.div
        initial={{ opacity: 0, x: -10 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.5 }}
        className="absolute z-10"
        style={{ left: "59.8%", top: "64%" }}
      >
        <div className="flex items-center gap-1.5 bg-[#0A0A0A]/85 backdrop-blur-sm border border-[#EE1D25]/30 px-3 py-2 rounded-sm shadow-lg">
          <MapPin size={12} className="text-[#EE1D25] shrink-0" />
          <div>
            <p className="text-[10px] md:text-[11px] text-[#F3F4F6] font-heading font-semibold leading-tight">P&eacute;cs, Hungary</p>
            <p className="text-[8px] md:text-[9px] text-[#9CA3AF] font-mono leading-tight">PTE VNL / SZKK</p>
          </div>
        </div>
      </motion.div>

      {/* Legend */}
      <div className="absolute bottom-3 left-3 flex items-center gap-4 bg-[#0A0A0A]/80 backdrop-blur-sm border border-[#1F2937] px-3 py-2 rounded-sm">
        <div className="flex items-center gap-1.5">
          <div className="w-2 h-2 rounded-full bg-[#5B6EBF]" />
          <span className="text-[9px] text-[#9CA3AF] font-mono">BSL-4 Laboratory</span>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="w-2.5 h-2.5 rounded-full bg-[#EE1D25]" />
          <span className="text-[9px] text-[#9CA3AF] font-mono">RoLink / PTE VNL</span>
        </div>
      </div>

      {/* Source */}
      <div className="absolute bottom-3 right-3 bg-[#0A0A0A]/60 px-2 py-1 rounded-sm">
        <span className="text-[8px] text-[#4B5563] font-mono">Source: thebulletin.org/global-biolabs</span>
      </div>
    </div>
  );
}
